<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content">

  <div class="contact-form-container">
    <h1>{{getString("contactUs")}}</h1>
    {{getString('contactText')}}
    <app-feedback-form></app-feedback-form>
  </div>

</div>
